var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          columns: _vm.columns,
          "other-params": { userId: _vm.userId },
          "checkbox-config": _vm.checkboxConfig,
          "toolbar-config": _vm.toolbarConfig,
          "print-config": _vm.printConfig,
          "import-config": _vm.importConfig,
          "export-config": _vm.exportConfig,
          cellClick: _vm.chooseRow,
          cellDbClick: _vm.updateRow,
        },
        on: { "toolbar-addData": _vm.addRow },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "btns_box",
                      staticStyle: { padding: "20px 0" },
                    },
                    [
                      _c(
                        "vxe-button",
                        { on: { click: _vm.showAssignPopFunc } },
                        [_vm._v(" 分配 ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择分配人",
            centered: "",
            closable: true,
            footer: null,
            maskClosable: true,
            width: 1200,
          },
          model: {
            value: _vm.showAssignPop,
            callback: function ($$v) {
              _vm.showAssignPop = $$v
            },
            expression: "showAssignPop",
          },
        },
        [
          _vm.showAssignPop
            ? _c("sonDeptUsersList", {
                ref: "sonDeptUsersList",
                attrs: { assignIdArr: _vm.assignIdArr, type: 2 },
                on: {
                  closeParent: _vm.closeDetailPop,
                  openParent: _vm.openDetailPop,
                  close: _vm.closePop,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }